import dom from '../../utils/dom';
import PaymentPlanSelectionFormModal from './PaymentPlanSelectionFormModal';


function initPaymentPlanSelection() {
  const $el = dom.find('.tn-payment-plan-selection');
  const $btnSelectPlan = dom.findFrom($el, '.tn-payment-plan-selection__btn-select-plan');
  const $form = dom.findFrom($el, '.tn-payment-plan-selection__form');

  const selectionFormModal = new PaymentPlanSelectionFormModal($form);

  $btnSelectPlan.addEventListener('click', async () => {
    selectionFormModal.getPaymentPlanSelection($btnSelectPlan);
  });
}

export default initPaymentPlanSelection;
